export default function formatHotelRoomName(room, bed) {
  return `${room?.name} ${bed?.name ? `(${bed?.name})` : ''}`;
}
